<template>
    <div>
        <el-form :model="obj" :rules="rules" ref="obj" label-width="100px" class="demo-ruleForm">
            <el-row class="display-flex-auto background" style="z-index: 11">
                <el-col :span="18" style="background: #212435">
                    <el-container>
                        <el-header style="padding: 0;">
                            <div class="display-flex create-header">
                                <div class="f16-content font-weight7 create-header-left">
                                    创建角色
                                </div>
                                <div class="create-header-right" @click="routerPush">
                                    <div style="position: absolute;right: 20px;">
                                        <i class="el-icon-error"></i>
                                    </div>
                                </div>
                            </div>
                        </el-header>
                        <el-main class="display-flex">
                            <div class="create-content-left ">
                                <div v-if="obj.model ==='1'">
                                    <img src="../../../static/img/nanjuese.png" alt="">
                                </div>
                                <div v-if="obj.model ==='2'">
                                    <img src="../../../static/img/nvjuese.png" alt="">
                                </div>
                            </div>
                            <div class="create-content-right  ">
                                <div class="create-content-right-box">
                                    <div>
                                        <el-form-item label="角色" prop="value">
                                            <div class="w280">
                                                <el-select v-model="obj.value">
                                                    <el-option
                                                            v-for="item in options"
                                                            :key="item.value"
                                                            :label="item.label"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div>
                                        <el-form-item label="账号" prop="userName">
                                            <div class="w280">
                                                <el-input onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" :maxlength="8"
                                                          :minlength="6" v-model.trim="obj.userName"
                                                          placeholder=""></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div>
                                        <el-form-item label="密码" prop="password">
                                            <div class="w280">
                                                <el-input onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" :maxlength="8"
                                                          :minlength="6" v-model.trim="obj.password"
                                                          placeholder=""></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div>

                                        <el-form-item label="昵称" prop="nickName">
                                            <div class="w280">
                                                <el-input :maxlength="8" :minlength="1" v-model.trim="obj.nickName"
                                                          placeholder=""></el-input>
                                            </div>
                                        </el-form-item>

                                    </div>
                                    <div>
                                        <el-form-item label="出生日期" required>
                                            <el-form-item prop="birth">
                                                <div class="w280">
                                                    <el-date-picker
                                                            :picker-options="pickerOptions0"
                                                            type="date"
                                                            v-model="obj.birth"
                                                            value-format="yyyy-MM-dd"
                                                            placeholder="选择日期">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                        </el-form-item>
                                    </div>
                                    <div>
                                        <div>
                                          <span @click="check(0)">
                                            <img v-if="boy" src="../../../static/img/man.png" alt="">
                                          </span>
                                            <span @click="check(1)">
                                            <img v-if="!boy" src="../../../static/img/man-xuanzhong.png" alt="">
                                          </span>
                                        </div>
                                        <div>
                                          <span @click="check(2)">
                                            <img v-if="!girl" src="../../../static/img/woman.png" alt="">
                                          </span>
                                            <span @click="check(3)">
                                            <img v-if="girl" src="../../../static/img/woman-xuanzhong拷贝.png" alt="">
                                          </span>
                                        </div>
                                    </div>
                                    <div>
                                        <el-button type="primary" @click="account(obj)" round>创建账号</el-button>
                                    </div>
                                </div>
                            </div>
                        </el-main>
                    </el-container>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>

    export default {
        name: "index",
        data() {
            return {
                //日期范围控制
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },

                //校验规则
                rules: {
                    value: [
                        {required: true, message: '请选择活动区域', trigger: 'change'}
                    ],
                    nickName: [
                        {required: true, message: '请填写昵称', trigger: 'blur'},
                        {min: 1, max: 9, message: '长度在 1 到 8 个字符', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请填写密码', trigger: 'blur'},
                        {min: 6, max: 9, message: '长度在 6 到 8 个字符', trigger: 'blur'}
                    ],
                    userName: [
                        {required: true, message: '请填写账号', trigger: 'blur'},
                        {min: 6, max: 9, message: '长度在 6 到 8 个字母或数字', trigger: 'blur'}
                    ],
                    birth: [
                        {required: true, message: '请选择日期', trigger: 'change'}
                    ]
                },

                obj: {
                    userName: '',
                    password: '',
                    nickName: '',
                    value: '2',
                    birth: '',
                    model: '2',
                },
                girl: true,
                boy: true,
                options: [{
                    value: '2',
                    label: '学生'
                }, {
                    value: '3',
                    label: '老师'
                },],


            }
        },
        methods: {
            /*1男  2女*/
            check(index) {
                if (index === 0) {
                    this.girl = false
                    this.boy = false
                    this.obj.model = '1'
                } else if (index === 2) {
                    this.girl = true
                    this.boy = true
                    this.obj.model = '2'
                }

            },
            routerPush() {

                this.$router.push({
                    path: '/login',
                })
            },

            //注册账号信息
            account(obj) {
                console.log(this.$refs.obj.validate);
                this.$refs.obj.validate((valid) => {
                    if (valid) {
                        let data = {
                            roleId: this.obj.value,
                            password: this.obj.password,
                            userName: this.obj.userName,
                            sex: this.obj.model,
                            nikiName: this.obj.nickName,
                            birth: this.obj.birth
                        };
                        this.$axios.post(this.URL.register, data).then(res => {
                            if (res.status === 200) {
                                this.$notify({
                                    title: '成功',
                                    message: '注册账号成功',
                                    type: 'success',
                                });
                                this.$router.push({
                                    path: '/login',
                                })
                            }
                            if (res.msg === "already") {
                                this.$notify.error({
                                    title: '错误',
                                    message: '账号已存在，请重新输入'
                                });
                            }
                        })
                    } else {
                        console.log('请填写完整信息');
                        return false;
                    }
                });


            }
        }
    }
</script>

<style lang="less" scoped>
    .background {
        background: url("../../../static/img/quxian.png");
    }

    .display-flex-auto {
        height: 100vh !important;

    }

    .el-input__inner {
        padding-left: 15px
    }

    .create-header {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .create-header-left {
        border-radius: 0 20% 20% 0;
        width: 20%;
        line-height: 60px;
        text-align: center;
        height: 60px;
        background: #ffffff;
    }

    .create-header-right {
        line-height: 35px;
        background: #ffffff;
        position: relative;
        width: 100%;
        height: 35px;
    }

    .create-content-left {
        width: 40%;
        img {
            width: 50%;
        }
        .el-input__inner {
            padding-left: 15px
        }
    }

    .create-content-right {
        width: 60%;
        .create-content-right-box {
            :first-child div {
                margin-top: 0;
            }
            div {
                margin: 0 auto;
                font-size: 16px;
                color: #ffffff;
                display: flex;
                align-items: center;
                margin-top: 15px;
            }
        }
    }

    .w280 {
        width: 280px;
    }
</style>



// WEBPACK FOOTER //
// src/views/createCharacter/index.vue